import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BaseStateService {
  getItem(key: string): string | null {
    try{
      return localStorage.getItem(key);
    }catch(error){
      console.error("Erro ao obter item do localStorage:", error);
      return null;
    }    
  }

  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}